export default class YoutubeManager {
    constructor(){

        this.player = {};
        this.yt = {};
        this.width = {};
        this.height = {};

        this.$target = $('#js__youtube');
        this.$icon = $('#p-news-movie .icon');

        this.ease = CustomEase.create("custom", "M0,0,C0.126,0.382,0.282,0.674,0.44,0.822,0.632,1.002,0.818,1.001,1,1");

        this.status = {
            load : false,
            play : false,
            pause : true
        }

    }
    init(){

        let domID = 'js__youtube';
        let id = this.$target.data('id');

        let _change = (event) => {
            this.yt[domID] = event.data;
            if (this.yt[domID] == YT.PlayerState.ENDED) {
                this.$icon.show(0);
                TweenMax.to(this.$icon, .2 , {
                    scale:1,
                    opacity: 1,
                    ease: this.ease
                });
                event.target.stopVideo();
            }else if(this.yt[domID] == YT.PlayerState.PLAYING){
                TweenMax.to(this.$icon, .2 , {
                    scale:0.6,
                    opacity: 0,
                    ease: this.ease
                });
            }
        };

        this.width[domID] = document.getElementById(domID).clientWidth;
        this.height[domID] = document.getElementById(domID).clientHeight;


        this.player[domID] = new YT.Player(domID, {
            width: this.width[domID],
            height: this.height[domID],
            videoId: id,
            events: {
                'onStateChange': _change
            },
            playerVars: {
                'autoplay' : 0,
                'html5': 1,
                'modestbranding': 1,
                //'controls':0,
                'rel':0,
                'enablejsapi':1,
                'showinfo':0,
                'loop':0,
                'playlist':id
            },
        });
    }

    // change(event){
    //     //let _this = this;
    //     //console.log(this.player);
    //     //this.yt = event.data;
    //     return event.data;
    // }


    play(domID){
        if(this.param.displayType === 'sp'){
            this.player[domID].mute();
        }
        this.player[domID].playVideo();
    }

    resize(){

        // if($("#"+param.youtube.domID)[0]){
        //     this.width = $("#"+param.youtube.domID).innerWidth();
        //     this.height = $("#"+param.youtube.domID).innerHeight();
        // }



    }


}
